var cov_27qfehoi7w = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/user/custom_right/customRightCtrl.js',
      hash = '29e123cfae60d9bbc6f644d18497ca546c8ef838',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/user/custom_right/customRightCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 3,
          column: 3
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 52
          },
          end: {
            line: 1,
            column: 53
          }
        },
        loc: {
          start: {
            line: 1,
            column: 167
          },
          end: {
            line: 3,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {},
    s: {
      '0': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_27qfehoi7w.s[0]++;
angular.module('app').controller('customRightCtrl', function ($scope, $rootScope, SweetAlert, $translate, $deltaActor, $CRUDService, $otherHttpService, $deltahttp, $filter) {
  cov_27qfehoi7w.f[0]++;
});